import React, { useEffect, useState } from "react";
import { useIsFocused } from "@react-navigation/native";
import { _goToAddProduct } from "routers/helper";

import { View, SafeAreaView } from "react-native";
import {
  Input,
  Empty,
  Error,
  Button,
  Header,
  Loading,
  ProductBox,
  AddButtonFloat,
  AnimatedInfinityList,
} from "components";
import Filters, { ProductsFiltersT } from "./Filters";
import SelectedFiltersView from "screens/components/SelectedFiltersView";

import { useProducts } from "clients/apis";

import { colors, sizes, strings } from "assets/constants";
import { mq, conditions, liveSearchInput } from "utils";
import { filtersItems } from "assets/data";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { useChmod, useFlag } from "hooks";
import css from "styles";

let timer: ReturnType<typeof setTimeout>;

export default function Products() {
  const { chmod } = useChmod();
  const isFocused = useIsFocused();

  const {
    company: { color },
  } = useRecoilValue(authAtom);

  const { flg: typing, on: startTyping, off: stopTyping } = useFlag();
  const { flg: filters, on: showFilters, off: hideFilters } = useFlag();

  const [search, setSearch] = useState("");
  const [qs, setQs] = useState<ProductsFiltersT>({});
  const _onApplyFilters = (newFilters: ProductsFiltersT) => {
    hideFilters();
    setQs(newFilters);
  };

  const {
    data,
    error,
    isError,
    refetch,
    isLoading,
    isRefetching,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useProducts({ title: search, categoryId: qs.category?.id });

  useEffect(() => {
    isFocused && refetch();
  }, [isFocused, refetch]);

  const _renderItem = (items: []) => {
    return (
      <View style={{ ...css.wrap, ...css.rRowCenterAlignSpaceBetween }}>
        {items.map((product: ProductT, key: number) => (
          <View key={String(key)} style={css.responsiveBoxContainer}>
            <ProductBox product={product} />
          </View>
        ))}
      </View>
    );
  };

  const _renderContent = () => {
    if (isLoading || typing) {
      return <Loading style={{ marginTop: mq(20) }} />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    if (data?.pages?.[0]?.data?.data?.length === 0) {
      return (
        <Empty style={{ marginTop: mq(20) }} message={strings.no_product} />
      );
    }

    return (
      <AnimatedInfinityList
        onRefresh={refetch}
        responseData={data}
        hasNextPage={hasNextPage}
        renderItemList={_renderItem}
        fetchNextPage={fetchNextPage}
        isFetchingNextPage={isFetchingNextPage}
        paddingTop={sizes.space}
        paddingBottom={70}
      />
    );
  };

  return (
    <>
      <Header title={strings.products} />
      <>
        <SafeAreaView style={{ ...css.container, ...css.screenBg }}>
          <View
            style={{
              ...css.paddingH,
              ...css.rowCenterAlign,
              marginTop: sizes.space,
            }}
          >
            <Input
              onChangeText={(text) =>
                liveSearchInput(
                  text,
                  search,
                  setSearch,
                  timer,
                  startTyping,
                  stopTyping
                )
              }
              placeholder={strings.search}
              icon={{ name: "search" }}
              hideError
              leftComponent={
                <Button
                  onPress={showFilters}
                  left={4}
                  square={38}
                  radius={sizes.radius.lg}
                  icon={{ name: "sliders", color, size: 24 }}
                  bgColor={colors.white}
                />
              }
            />
          </View>

          {conditions.isFiltered(qs) && (
            <View style={{ paddingTop: sizes.space }}>
              <SelectedFiltersView
                filters={qs}
                onChange={setQs}
                filterItems={filtersItems.products}
              />
            </View>
          )}

          {_renderContent()}

          <Filters
            visible={filters}
            initials={qs}
            apply={_onApplyFilters}
            hide={hideFilters}
          />
        </SafeAreaView>

        {chmod("product", "POST") && (
          <AddButtonFloat onPress={_goToAddProduct} />
        )}
      </>
    </>
  );
}
